/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KpiResponse
 */
export interface KpiResponse {
    /**
     * 
     * @type {number}
     * @memberof KpiResponse
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof KpiResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KpiResponse
     */
    attribute: string;
    /**
     * 
     * @type {number}
     * @memberof KpiResponse
     */
    weight: number;
    /**
     * 
     * @type {boolean}
     * @memberof KpiResponse
     */
    directionUp: boolean;
    /**
     * 
     * @type {string}
     * @memberof KpiResponse
     */
    lobKey: string;
    /**
     * 
     * @type {string}
     * @memberof KpiResponse
     */
    officeKey: string;
}

/**
 * Check if a given object implements the KpiResponse interface.
 */
export function instanceOfKpiResponse(value: object): value is KpiResponse {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('attribute' in value) || value['attribute'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('directionUp' in value) || value['directionUp'] === undefined) return false;
    if (!('lobKey' in value) || value['lobKey'] === undefined) return false;
    if (!('officeKey' in value) || value['officeKey'] === undefined) return false;
    return true;
}

export function KpiResponseFromJSON(json: any): KpiResponse {
    return KpiResponseFromJSONTyped(json, false);
}

export function KpiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): KpiResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'id': json['id'] == null ? undefined : json['id'],
        'attribute': json['attribute'],
        'weight': json['weight'],
        'directionUp': json['directionUp'],
        'lobKey': json['lobKey'],
        'officeKey': json['officeKey'],
    };
}

export function KpiResponseToJSON(json: any): KpiResponse {
    return KpiResponseToJSONTyped(json, false);
}

export function KpiResponseToJSONTyped(value?: KpiResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'id': value['id'],
        'attribute': value['attribute'],
        'weight': value['weight'],
        'directionUp': value['directionUp'],
        'lobKey': value['lobKey'],
        'officeKey': value['officeKey'],
    };
}

